// extracted by css-extract-rspack-plugin
var _1 = "checkmark__qqsmX";
var _2 = "offer-bullet__qHlp8";
var _3 = "offer-container__Q6rit";
var _4 = "offer-header__G0Y5T";
var _5 = "offer-text__nkbs0";
export { _1 as "checkmark", _2 as "offer-bullet", _3 as "offer-container", _4 as "offer-header", _5 as "offer-text" }
export default { "checkmark": _1, "offer-bullet": _2, "offer-container": _3, "offer-header": _4, "offer-text": _5 }
